import { DropdownItemProps } from "semantic-ui-react";

export const tsos = [
    "50HZT",
    "AMPRION",
    "APG",
    "CEPS",
    "CREOS",
    "ELES",
    "ELIA",
    "HOPS",
    "MAVIR",
    "PSE",
    "RTE",
    "SEPS",
    "TEL",
    "TNG",
    "TTG",
    "TTN",
];

export const tsosProps: DropdownItemProps[] = tsos.map(x => ({
    key: x,
    value: x,
    text: x,
}));

export const tsoCountries: { [key: string]: string } = {
    D8: "50HZT",
    D7: "AMPRION",
    AT: "APG",
    CZ: "CEPS",
    SI: "ELES",
    BE: "ELIA",
    HR: "HOPS",
    HU: "MAVIR",
    PL: "PSE",
    FR: "RTE",
    SK: "SEPS",
    RO: "TEL",
    D4: "TNG",
    D2: "TTG",
    NL: "TTN",
};
